// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const AUTOCOMPLETE_UPDATE_INPUT = 'AUTOCOMPLETE_UPDATE_INPUT';
export const updateAutocompleteInput = makeActionCreator(AUTOCOMPLETE_UPDATE_INPUT, 'input');
